import { render } from "./VeteranInfo.vue?vue&type=template&id=755495de"
import script from "./VeteranInfo.vue?vue&type=script&lang=js"
export * from "./VeteranInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__